import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Calculator as CalcIcon, ArrowRight } from "lucide-react";

const sel = "w-full rounded-xl border border-line bg-white px-4 py-3 text-[15px] outline-none focus:border-gold";

export default function CostCalculator() {
  const [packages, setPackages] = useState([]);
  const [area, setArea] = useState("");
  const [floors, setFloors] = useState(1);
  const [pkgId, setPkgId] = useState("");
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/packages").then((r) => {
      const list = r.data || [];
      setPackages(list);
      if (list[0]) setPkgId(list[0].id);
    }).catch(() => {});
  }, []);

  const calc = async () => {
    setErr(""); setResult(null);
    const a = parseFloat(area);
    if (!a || a <= 0) { setErr("Enter a valid built-up area."); return; }
    if (!pkgId) { setErr("Select a construction package."); return; }
    try {
      const r = await api.post("/calculate", { area: a, package_id: pkgId, floors: parseInt(floors) || 1 });
      setResult(r.data);
    } catch { setErr("Could not calculate right now. Please try again."); }
  };

  return (
    <div className="rounded-xl2 bg-white border border-line p-5 md:p-6 h-full flex flex-col" data-testid="home-calculator">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center"><CalcIcon size={20} className="text-gold" /></span>
        <h3 className="text-lg font-bold text-ink">Construction Cost Calculator</h3>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <label className="text-xs font-semibold text-ink">Built-up Area (sq.ft)</label>
          <input type="number" className={sel + " mt-1.5"} value={area} onChange={(e) => setArea(e.target.value)} placeholder="e.g. 2000" data-testid="calc-area" />
        </div>
        <div>
          <label className="text-xs font-semibold text-ink">Floors</label>
          <input type="number" min="1" className={sel + " mt-1.5"} value={floors} onChange={(e) => setFloors(e.target.value)} data-testid="calc-floors" />
        </div>
        <div>
          <label className="text-xs font-semibold text-ink">Package</label>
          <select className={sel + " mt-1.5"} value={pkgId} onChange={(e) => setPkgId(e.target.value)} data-testid="calc-package">
            {packages.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
      </div>
      <button onClick={calc} data-testid="calc-submit" className="mt-4 inline-flex items-center justify-center gap-2 rounded-xl bg-gold text-white font-semibold py-3 shadow-gold hover:bg-gold-dark transition-colors">
        Calculate Estimate
      </button>
      {err && <p className="text-sm text-red-500 mt-2" data-testid="calc-error">{err}</p>}
      {result && (
        <div className="mt-4 rounded-xl bg-sand border border-line p-4 text-center" data-testid="calc-result">
          <div className="text-xs text-muted">Estimated Cost · {Number(result.total_area).toLocaleString("en-IN")} sq.ft × ₹{result.rate}/sq.ft</div>
          <div className="text-2xl font-extrabold text-ink mt-1">₹{Number(result.estimate).toLocaleString("en-IN")}</div>
          <p className="text-[11px] text-muted mt-2 leading-relaxed">{result.disclaimer}</p>
        </div>
      )}
      <div className="mt-auto pt-4">
        <Link to="/calculator" className="text-sm font-semibold text-gold inline-flex items-center gap-1 hover:gap-2 transition-all" data-testid="calc-detailed-link">
          Open detailed calculator <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
